import { _ as K } from "./index742.mjs";
import { e as X } from "./index772.mjs";
import { g as Y } from "./index767.mjs";
import { f as Z } from "./index773.mjs";
import { d as rr } from "./index740.mjs";
import { o as er } from "./index774.mjs";
import { s as or } from "./index775.mjs";
import { s as tr } from "./index776.mjs";
import { a as ir } from "./index777.mjs";
import { i as ar } from "./index761.mjs";
import { i as nr } from "./index778.mjs";
import { a as sr } from "./index779.mjs";
import { s as fr } from "./index780.mjs";
import { t as vr } from "./index781.mjs";
import { m as cr } from "./index782.mjs";
import { h as lr } from "./index783.mjs";
import { p as mr } from "./index784.mjs";
import { q as pr } from "./index785.mjs";
import { i as ur } from "./index786.mjs";
import { p as dr } from "./index787.mjs";
import { p as hr } from "./index788.mjs";
import "./index789.mjs";
import { __exports as Er } from "./index790.mjs";
var Nr = K, N = X, a = Y, p = Z, w = rr, $ = er, Pr = or, Cr = tr, Ir = ir, E = ar, Tr = nr, Sr = sr, yr = fr, H = vr.set, O = cr, Or = lr, br = mr, Rr = pr, k = ur, P = dr, b = hr, M = Er, C = "Promise", x = b.CONSTRUCTOR, _r = b.REJECTION_EVENT, jr = b.SUBCLASSING, I = k.getterFor(C), Dr = k.set, c = P && P.prototype, n = P, d = c, J = a.TypeError, T = a.document, R = a.process, S = M.f, wr = S, $r = !!(T && T.createEvent && a.dispatchEvent), V = "unhandledrejection", Ur = "rejectionhandled", U = 0, B = 1, gr = 2, _ = 1, G = 2, h, g, Ar, A, F = function(r) {
  var e;
  return Tr(r) && E(e = r.then) ? e : !1;
}, q = function(r, e) {
  var o = e.value, t = e.state === B, i = t ? r.ok : r.fail, s = r.resolve, u = r.reject, f = r.domain, v, j, D;
  try {
    i ? (t || (e.rejection === G && Hr(e), e.rejection = _), i === !0 ? v = o : (f && f.enter(), v = i(o), f && (f.exit(), D = !0)), v === r.promise ? u(new J("Promise-chain cycle")) : (j = F(v)) ? p(j, v, s, u) : s(v)) : u(o);
  } catch (z) {
    f && !D && f.exit(), u(z);
  }
}, Q = function(r, e) {
  r.notified || (r.notified = !0, O(function() {
    for (var o = r.reactions, t; t = o.get(); )
      q(t, r);
    r.notified = !1, e && !r.rejection && Lr(r);
  }));
}, W = function(r, e, o) {
  var t, i;
  $r ? (t = T.createEvent("Event"), t.promise = e, t.reason = o, t.initEvent(r, !1, !0), a.dispatchEvent(t)) : t = { promise: e, reason: o }, !_r && (i = a["on" + r]) ? i(t) : r === V && Or("Unhandled promise rejection", o);
}, Lr = function(r) {
  p(H, a, function() {
    var e = r.facade, o = r.value, t = L(r), i;
    if (t && (i = br(function() {
      N ? R.emit("unhandledRejection", o, e) : W(V, e, o);
    }), r.rejection = N || L(r) ? G : _, i.error))
      throw i.value;
  });
}, L = function(r) {
  return r.rejection !== _ && !r.parent;
}, Hr = function(r) {
  p(H, a, function() {
    var e = r.facade;
    N ? R.emit("rejectionHandled", e) : W(Ur, e, r.value);
  });
}, l = function(r, e, o) {
  return function(t) {
    r(e, t, o);
  };
}, m = function(r, e, o) {
  r.done || (r.done = !0, o && (r = o), r.value = e, r.state = gr, Q(r, !0));
}, y = function(r, e, o) {
  if (!r.done) {
    r.done = !0, o && (r = o);
    try {
      if (r.facade === e)
        throw new J("Promise can't be resolved itself");
      var t = F(e);
      t ? O(function() {
        var i = { done: !1 };
        try {
          p(
            t,
            e,
            l(y, i, r),
            l(m, i, r)
          );
        } catch (s) {
          m(i, s, r);
        }
      }) : (r.value = e, r.state = B, Q(r, !1));
    } catch (i) {
      m({ done: !1 }, i, r);
    }
  }
};
if (x && (n = function(e) {
  Sr(this, d), Ir(e), p(h, this);
  var o = I(this);
  try {
    e(l(y, o), l(m, o));
  } catch (t) {
    m(o, t);
  }
}, d = n.prototype, h = function(e) {
  Dr(this, {
    type: C,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new Rr(),
    rejection: !1,
    state: U,
    value: null
  });
}, h.prototype = w(d, "then", function(e, o) {
  var t = I(this), i = S(yr(this, n));
  return t.parent = !0, i.ok = E(e) ? e : !0, i.fail = E(o) && o, i.domain = N ? R.domain : void 0, t.state === U ? t.reactions.add(i) : O(function() {
    q(i, t);
  }), i.promise;
}), g = function() {
  var r = new h(), e = I(r);
  this.promise = r, this.resolve = l(y, e), this.reject = l(m, e);
}, M.f = S = function(r) {
  return r === n || r === Ar ? new g(r) : wr(r);
}, E(P) && c !== Object.prototype)) {
  A = c.then, jr || w(c, "then", function(e, o) {
    var t = this;
    return new n(function(i, s) {
      p(A, t, i, s);
    }).then(e, o);
  }, { unsafe: !0 });
  try {
    delete c.constructor;
  } catch {
  }
  $ && $(c, d);
}
Nr({ global: !0, constructor: !0, wrap: !0, forced: x }, {
  Promise: n
});
Pr(n, C, !1);
Cr(C);
